<svg:g
  (mouseover)="handleMouseEvent($event, 'wholeShape')"
  (mouseout)="handleMouseEvent($event, 'wholeShape')"
>
  <svg:g
    h3ShapeFill
    [selected]="selected"
    [points]="rectanglePoints$ | async"
    [visibility]="visibility$ | async"
    [scale$]="scale$"
    (mousedown)="handleMouseEvent($event, 'shape')"
    (dblclick)="handleMouseEvent($event, 'shape')"
    (mouseup)="handleMouseEvent($event, 'shape')"
  />
  <svg:g
    h3InteractiveBorder
    [points$]="rectanglePoints$"
    [shapeStore]="shapeStore"
  />
  <svg:polyline
    *ngIf="sliderLinePointString$ | async as points"
    class="slider-line"
    [attr.points]="points"
  />
  <svg:g
    *ngIf="sliderLinePoints$ | async as points"
    h3InteractiveBorderLine
    [p1]="points[0]"
    [p2]="points[1]"
    [lineIndex]="SLIDER_INDEX"
    [shapeStore]="shapeStore"
  />
  <svg:g
    *ngFor="let point of allSliderPointInfo$ | async"
    class="slider-point"
    [h3Subpoint]="point"
    [shapeSelected]="selected"
    (mousedown)="handleMouseEvent($event, 'subpoint', SLIDER_INDEX)"
    (dblclick)="handleMouseEvent($event, 'shape')"
  />
  <ng-container *ngIf="showBorderAndSubpoints$ | async">
    <svg:g
      *ngFor="
        let subpointInfo of allSubpointInfo$ | async;
        trackBy: trackByIndex
      "
      [h3Subpoint]="subpointInfo"
      [shapeSelected]="selected"
      (mousedown)="
        handleMouseEvent($event, 'subpoint', subpointInfo.subpointIndex)
      "
      (dblclick)="handleMouseEvent($event, 'shape')"
    />
  </ng-container>
  <svg:g
    *ngIf="centerText$ | async as text"
    [h3SvgText]="text"
    [scale$]="scale$"
    [location]="center$ | async"
  />
</svg:g>
